import { render, staticRenderFns } from "./RoomGridPromotionItem.vue?vue&type=template&id=a5e4195e&"
import script from "./RoomGridPromotionItem.vue?vue&type=script&lang=js&"
export * from "./RoomGridPromotionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports